export default {
  name: "cart",
  store() {
    return {
      cart: null,
      isLoading: true,
      init() {
        this.fetchCart();
      },
      async fetchCart() {
        await fetch(`/cart.js`)
          .then((response) => {
            if (!response.ok) {
              throw new Error("Network response was not ok");
            }
            return response.json();
          })
          .then((data) => {
            this.cart = data;
            this.isLoading = false;
          })
          .catch((error) => {
            console.error("Error fetching cart:", error);
          });
      },
      async getCart() {
        if (!this.isLoading) return this.cart;

        return new Promise((resolve) => {
          const intervalId = setInterval(() => {
            if (!this.isLoading) {
              clearInterval(intervalId);
              resolve(this.cart);
            }
          }, 250);
        });
      }
    };
  },
};
